import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import RadioButton from '../radio-button-group/containers/radio-button';
import RadioButtonGroup from '../radio-button-group';
import FieldStatus from '../field-status';

const defaultRules = {};

const RadioButtonGroupField = ({
  name,
  control,
  options,
  rules = defaultRules,
  onChange = Function.prototype,
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value, event) => {
      field.onChange(value);
      onChange(value, event);
    },
    [field, onChange]
  );

  return (
    <RadioButtonGroup name={name} selectedValue={field.value} onChange={handleChange}>
      {options.map(({ value, label, isLabelBold }, index) => {
        const id = `${field.name}-${index}`;

        return (
          <RadioButton key={id} id={id} value={value} label={label} isLabelBold={isLabelBold} />
        );
      })}
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </RadioButtonGroup>
  );
};

RadioButtonGroupField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isLabelBold: PropTypes.bool,
    })
  ).isRequired,
  onChange: PropTypes.func,
};

export default RadioButtonGroupField;
